class AgeGate {
  constructor() {
    try {
      this.modal = null;
      this.cookieName = 'smokeys_age_verified';
      this.cookieDays = 90;
      this.minAge = null; // Province-agnostic
      this.locationPopupOpen = false;
      this.init();
    } catch (error) {
      console.error('[Age Gate] Initialization error:', error);
    }
  }

  init() {
    // Check if crawler/bot
    if (this.isCrawler()) {
      return;
    }
    
    // Check if user has already verified their age
    if (this.hasVerifiedAge()) {
      return;
    }

    // Listen for location popup state changes
    this.observeLocationPopup();

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.showAgeGate());
    } else {
      // Show immediately
      this.showAgeGate();
    }
  }
  
  isCrawler() {
    const userAgent = navigator.userAgent.toLowerCase();
    // Keep in sync with the Liquid list in snippets/age-gate.liquid
    const crawlers = ['googlebot', 'googleother', 'bingbot', 'slurp', 'duckduckbot', 'applebot', 'baiduspider', 'facebookexternalhit', 'twitterbot', 'linkedinbot', 'whatsapp', 'lighthouse', 'headlesschrome'];
    return crawlers.some(crawler => userAgent.includes(crawler));
  }

  observeLocationPopup() {
    // Check if location popup is open
    const checkLocationPopup = () => {
      const locationModal = document.getElementById('store-locator-modal');
      if (locationModal) {
        this.locationPopupOpen = locationModal.style.display === 'flex';
      }
    };

    // Use MutationObserver to watch for location popup changes
    const observer = new MutationObserver(() => {
      checkLocationPopup();
      // If location popup closes and age gate should be showing, show it
      if (!this.locationPopupOpen && this.modal && !this.hasVerifiedAge()) {
        this.modal.style.display = 'flex';
      }
    });

    // Start observing when DOM is ready
    const startObserving = () => {
      const locationModal = document.getElementById('store-locator-modal');
      if (locationModal) {
        observer.observe(locationModal, { attributes: true, attributeFilter: ['style'] });
        checkLocationPopup();
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  }

  hasVerifiedAge() {
    return localStorage.getItem(this.cookieName) === 'true' || 
           this.getCookie(this.cookieName) === 'true';
  }

  showAgeGate() {
    try {
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      // Show the age gate modal
      this.modal = document.getElementById('age-gate-modal');
      if (this.modal) {
        this.modal.style.display = 'flex';
        this.attachEventListeners();
        
        // Focus on the first button for accessibility
        setTimeout(() => {
          const firstButton = document.getElementById('age-gate-yes');
          if (firstButton) firstButton.focus();
        }, 100);
      } else {
        console.error('[Age Gate] Modal element not found');
        // If age gate modal doesn't exist, mark as verified to prevent blocking
        this.verifyAge();
      }
    } catch (error) {
      console.error('[Age Gate] Error showing age gate:', error);
      // On error, mark as verified to prevent blocking site
      this.verifyAge();
    }
  }

  attachEventListeners() {
    // Yes button
    const yesBtn = document.getElementById('age-gate-yes');
    if (yesBtn) {
      yesBtn.addEventListener('click', () => this.verifyAge());
    }

    // No button
    const noBtn = document.getElementById('age-gate-no');
    if (noBtn) {
      noBtn.addEventListener('click', () => this.denyAccess());
    }
  }

  verifyAge() {
    // Set verification in both localStorage and cookie
    localStorage.setItem(this.cookieName, 'true');
    this.setCookie(this.cookieName, 'true', this.cookieDays);
    
    // Hide modal and restore scroll
    this.hideModal();
    
    // Track event if analytics is available
    if (typeof gtag !== 'undefined') {
      gtag('event', 'age_verified', {
        'event_category': 'engagement',
        'event_label': 'button_click'
      });
    }
    
    // Dispatch event to trigger location popup if needed
    window.dispatchEvent(new Event('ageVerified'));
  }


  denyAccess() {
    // Track event
    if (typeof gtag !== 'undefined') {
      gtag('event', 'age_denied', {
        'event_category': 'engagement',
        'event_label': 'underage'
      });
    }

    // Don't set any permanent denial - just redirect
    // This allows them to try again if they come back
    window.location.href = 'https://www.google.com';
  }

  hideModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
    }
    document.body.style.overflow = '';
  }


  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

// Initialize age gate when script loads
try {
  // Only initialize if we're not in Shopify theme editor
  if (!window.Shopify || !window.Shopify.designMode) {
    window.ageGateInstance = new AgeGate();
  }
} catch (error) {
  console.error('[Age Gate] Failed to initialize:', error);
}